<template>
    <div class="sharedome">
        <h3>{{$t('kmewm')}}</h3>
        <p style="margin-top:75px">{{tiels}} </p>
         <vue-qr 
        :size="220"
        :margin="10"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
        
      />
    </div>
</template>

<script>
import VueQr from 'vue-qr'
import CRC from "@/crc16xm/crc16array.js"
import AESHQT from "@/aeshqt/aes.js" 
// var  Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import {base64ToString,CharToHex} from '@/utils/index'
var flow_no = 0;
export default {
    components: {
        VueQr
    },
    data(){
        return{
            appSrc:'',
            clearTimeSet:'',
            keytiems:null,
            tiels:'',
            datalist:null,
            number:JSON.parse(window.localStorage.getItem('datauser')),
        }
    },
    mounted(){
        this.getHandlecode()
    },
    methods:{
        // 获取生成二维码参数
        getHandlecode(){
            let data={
                method:'co.wx.visit.click',
                code:this.$route.query.code
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    console.log(res.data.data.key_time)
                    let keytiem = res.data.data.key_time
                    this.keytiems = res.data.data.key_time
                    this.datalist = res.data.data
                    let nowtime = new Date().getTime()/1000
                    if(nowtime>keytiem){
                        Toast.fail(this.$t('kmewmygq'))
                        this.tiels=this.$t('kmewmygq')
                        // this.qrCodeCreate()
                    }else{
                        this.handeldow()
                    }
                    
                    
                }else{
                    this.tiels=this.$t('kmewmygq')
                }
            })
        },
        handeldow(){
        // this.qrCodeCreate()
            this.clearTimeSet=setInterval( () =>{
                this.qrCodeCreate()
            }, 300);
        },

        qrCodeCreate(){
    
            let base64encrypt =base64ToString(this.datalist.encrypt) 
            console.log(`马工获取的encrypt`,this.datalist.encrypt)
            let encrypt = CharToHex(base64encrypt)

            let u8_src = encrypt.split(',').join('')

            // console.log(`马工获取解码后`,u8_src)

            //流水号 随机数(1000--2000)
            var random_number = 1000 + (flow_no++)%1000; //Math.floor(Math.random() * 1000 + 1000);
            // random_number = 1500;
            random_number = parseInt(random_number).toString(16).toUpperCase();
            random_number = this.checkHexZero(random_number);
            // random_number = 1500;

            console.log(`随机数`,random_number)

            // var utc_number = new Date().getTime() / 1000;
            var utc_number = this.keytiems
            console.log("时间："+utc_number);
            // utc_number = 1627625901;
            utc_number = parseInt(utc_number).toString(16).toUpperCase();
            utc_number = this.checkHexZero(utc_number);
            // utc_number = 1627625901;
            console.log("16进制时间戳: "+utc_number);

            var crc_source = u8_src + random_number + utc_number;
            // var crc_source =  random_number + utc_number;
            console.log("手机号+随机数+时间戳： "+crc_source);
            var len = crc_source.length / 2;
            var arr = new Uint8Array(len);
            var i;
            for(i=0;i<len;i++){
                arr[i] = parseInt(crc_source.substr(i*2, 2), 16);
            }
            var crc_result = CRC.CRC16func(arr)
            console.log("校验码: "+crc_result);



            var source = u8_src + random_number + utc_number + crc_result ;
            // var source = random_number + utc_number + crc_result ;

            console.log(`总字节`,source);

            var source_bytes = new Uint8Array(16);

            
            for(let i=0;i<16;i++){
                source_bytes[i] = parseInt(source.substr(i * 2,2),16);
            }

            console.log(`555`,source_bytes)

            let key = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1];
            let aes_res = AESHQT.encrypt(source_bytes,key);
            console.log(`AES加密后`,aes_res);

            let aes_bytes = new Uint8Array(aes_res.length/2);
            for (let i = 0; i < aes_res.length/2; i++) {
                aes_bytes[i] = parseInt(aes_res.substr(i * 2, 2), 16);
            }
            // console.log(`44`,aes_bytes);  
            
            let strDtae =  new Buffer(new Uint8Array(aes_bytes));

            let base64_str = strDtae.toString('base64')
            console.log(`最后base64加密`,base64_str)
            var aes_result ='T'+ base64_str;
            console.log(`最终结果`,aes_result)
            this.appSrc = aes_result
        },
        checkHexZero:function(hex){
            var out;
            if(hex.length % 2  == 1)
                out='0'+hex;
            else
                out=hex;
            return out;        
        },
    },
    beforeDestroy() {    //页面关闭时清除定时器  
        clearInterval(this.clearTimeSet);
    },
}
</script>
<style scoped>
.sharedome{
    width: 100%;
    height: 300px;
    margin-top:80px ;
}

</style>